export const SECTIONS = [
  { id: "profile", label: "Profile", href: "/settings/profile" },
  { id: "security", label: "Sign-in and security", href: "/settings/security" },
  { id: "preferences", label: "Preferences", href: "/settings/preferences" },
  { id: "billing", label: "Billing", href: "/settings/billing" },
] as const;

export type SectionId = (typeof SECTIONS)[number]["id"];

export function isSectionId(value: string | undefined): value is SectionId {
  return SECTIONS.some((s) => s.id === value);
}
